/**
 * Very naive: Returns whether the browser supports srcset/sizes on images.
 *
 * @return {boolean}
 */
export function isResponsiveImgSupported() {
    const img = document.createElement('img');
    return ('sizes' in img);
}
